import SegmentedControl from '@ingka/segmented-control';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { AgeGroupComponent, ageGroups } from '@inter-ikea-storageone/range-smastad';
import { useCore } from 'contexts/core';
import { usePlannerConfig } from 'contexts/plannerConfig';
import { getAgeGroup, setAgeGroup } from 'ducks/layout';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Title from 'ui/Typography/Title';
import { isMobile } from 'utils/platform';

const Wrapper = styled.div`
  margin: 0 ${({ theme }) => theme.space.mdl} 1rem;
`;

const AgeGroupSwitcher = () => {
  const dispatch = useDispatch();
  const currentAgeGroup = useSelector(getAgeGroup);
  const coreApi = useCore();
  const { plannerConfig } = usePlannerConfig();
  const { formatMessage } = useIntl();

  useEffect(() => {
    const proppingAgeGroupUpdated = (ageGroup: string) => {
      dispatch(setAgeGroup(ageGroup));
    };

    return coreApi.subscribe('proppingAgeGroupUpdated', ageGroup =>
      proppingAgeGroupUpdated(ageGroup)
    );
  }, [coreApi, dispatch]);

  useEffect(() => {
    if (currentAgeGroup) {
      const ageGroup = coreApi.entities
        .getScene()
        ?.getComponent<AgeGroupComponent>(AgeGroupComponent.id)?.ageGroup;
      if (ageGroup !== currentAgeGroup) {
        coreApi.entities.getScene()?.addComponent(new AgeGroupComponent(currentAgeGroup));
        coreApi.loadProppingCatalog(
          plannerConfig.productCatalogs.find(c => c.name === 'propping')!,
          currentAgeGroup
        );
      }
    }
  }, [coreApi, plannerConfig, currentAgeGroup]);

  return (
    <Wrapper>
      {!isMobile() && (
        <Title mb="s" type={ThemeFontStyleTypeEnum.headingXSmall}>
          {formatMessage({ id: 'storageone.ageGroup' })}
        </Title>
      )}
      <SegmentedControl
        items={[
          {
            label: formatMessage({ id: 'storageone.smastadAgeGroupBaby' })
          },
          {
            label: formatMessage({ id: 'storageone.smastadAgeGroupChildren' })
          },
          {
            label: formatMessage({ id: 'storageone.smastadAgeGroupTeens' })
          }
        ]}
        activeIndex={currentAgeGroup ? ageGroups.indexOf(currentAgeGroup) : 1}
        onClick={(eventObj, index) => {
          dispatch(setAgeGroup(ageGroups[index]));
        }}
      />
    </Wrapper>
  );
};

export default AgeGroupSwitcher;
